import { Box, Button, IconButton, Paper, Typography } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { useLocation, useNavigate } from 'react-router';
import '../Customer/CustomerScreens.scss';

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Box className='customer-screen'>
      <Box className='customer-shell'>
        <Box className='customer-topbar'>
          <IconButton className='customer-iconButton' onClick={() => navigate(-1)}>
            <ArrowBackRoundedIcon />
          </IconButton>
          <Typography className='customer-topbarTitle'>Payment</Typography>
          <Box sx={{ width: 46 }} />
        </Box>

        <Paper className='customer-card' sx={{ p: 3 }}>
          <Box className='checkout-successWrap'>
            <Box className='checkout-successBadge'>
              <CheckRoundedIcon sx={{ fontSize: 56 }} />
            </Box>
            <Typography sx={{ fontWeight: 700, fontSize: '2rem', mb: 1 }}>
              Payment Successful!
            </Typography>
            <Typography className='customer-muted' sx={{ mb: 3 }}>
              Thank you for your purchase.
            </Typography>
          </Box>
        </Paper>

        <Paper className='checkout-stickyFooter'>
          <Button
            className='customer-actionButton customer-actionButton--primary'
            fullWidth
            onClick={() => navigate('/checkout/e-receipt', { state: location.state })}
          >
            View Order
          </Button>
          <Button
            fullWidth
            sx={{ mt: 1.5, color: '#ff5c67', fontWeight: 700, textTransform: 'none' }}
            onClick={() => navigate('/checkout/e-receipt', { state: location.state })}
          >
            View E-Receipt
          </Button>
        </Paper>
      </Box>
    </Box>
  );
}
